(() => {
  const waitForCartDrawer = (timeout = 15000) => {
    if (window.OECartDrawer?.open) return Promise.resolve(true);

    return new Promise((resolve) => {
      const started = Date.now();
      const check = () => {
        if (window.OECartDrawer?.open) {
          resolve(true);
          return;
        }
        if (Date.now() - started >= timeout) {
          resolve(false);
          return;
        }
        requestAnimationFrame(check);
      };
      check();
    });
  };

  const afterReady = () => new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });

  const init = () => {
    document.querySelectorAll('[data-pdp-main-product]').forEach((root) => {
      if (root.dataset.pdpCartBridgeReady === 'true') return;

      const form = root.querySelector('[data-pdp-product-form]');
      const button = form?.querySelector('[data-add-to-cart]');
      const error = root.querySelector('[data-pdp-submit-error]');
      if (!form || !button) return;

      root.dataset.pdpCartBridgeReady = 'true';
      let waiting = false;

      const showError = (message = '') => {
        if (!error) return;
        error.textContent = message;
        error.hidden = !message;
      };

      button.addEventListener('click', async (event) => {
        if (button.disabled || waiting || window.OECartDrawer?.open) return;

        event.preventDefault();
        event.stopPropagation();
        waiting = true;
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        showError('Loading your basket…');

        try {
          const ready = await waitForCartDrawer();
          if (!ready) {
            showError('Basket is still loading. Please try again.');
            console.error('Cardology PDP: Personalize cart drawer did not become ready.');
            return;
          }

          await afterReady();
          showError();
          button.disabled = false;
          button.removeAttribute('aria-disabled');

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(button);
          } else {
            button.click();
          }
        } finally {
          waiting = false;
          if (!button.matches('[data-sold-out="true"]')) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        }
      });

      // The custom Personalize cart drawer (or the AOV capture handler) must
      // claim the submit before it reaches the form. Never allow the browser's
      // native product form submission to navigate to /cart.
      form.addEventListener('submit', (event) => {
        if (event.defaultPrevented) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showError('Basket is still loading. Please try again.');
        console.error('Cardology PDP: Unclaimed add-to-cart submit blocked.');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
